import React from 'react';
import FreestarAdSlot from '../shared/freestar-ad-slot';
import FreestarStickyFooter from '../shared/freestar-sticky-footer';
import FeedUserType from '../../common/feed-user-type';
import { MOBILE_AD_BREAKPOINT } from '../../utility/ads/should-use-mobile-ad';
import {
    TEAM_VIDEO_PAGE_STICKY_FOOTER_PLACEMENT,
    VIDEO_PAGE_SIDEBAR_PLACEMENT,
    VIDEO_PAGE_STICKY_FOOTER_PLACEMENT,
} from '../../utility/ads/freestar-placements';

// The CSS sidebar appears at 1056px, but Freestar only sizes this placement for a
// 300x250 from 1100px. Below that it would serve a 728x90 that doesn't fit.
// Freestar measures the page without the scrollbar (clientWidth), so we use the same
// width. A min-width media query includes the scrollbar and would show the slot
// while Freestar still requests a 728x90.
function isWideViewport() {
    return document.documentElement.clientWidth >= MOBILE_AD_BREAKPOINT;
}

export function isTeamOwnedVideo(owner) {
    return !!owner && owner.feedUserType === FeedUserType.Team;
}

// Renders the in-page sidebar slot on wide viewports and the sticky footer on
// narrow ones. React's unmount/mount on swap ensures the outgoing slot tears
// down before the incoming one registers. Team-owned videos use the team footer
// placement; the sidebar placement is the same for both.
class VideoPageAds extends React.Component {
    static propTypes = {
        isTeamOwned: React.PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = { isWide: typeof window !== 'undefined' ? isWideViewport() : false };
        this._onResize = this._onResize.bind(this);
    }

    componentDidMount() {
        // The page width also changes when the scrollbar appears, which fires no
        // resize event, so watch <html> itself where ResizeObserver is available.
        if (typeof window.ResizeObserver === 'function') {
            this._resizeObserver = new window.ResizeObserver(this._onResize);
            this._resizeObserver.observe(document.documentElement);
        } else {
            window.addEventListener('resize', this._onResize);
        }
        this._onResize();
    }

    componentWillUnmount() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        } else {
            window.removeEventListener('resize', this._onResize);
        }
    }

    _onResize() {
        const isWide = isWideViewport();
        if (isWide !== this.state.isWide) this.setState({ isWide });
    }

    render() {
        // No Freestar for known under-13 viewers, so don't leave an empty container.
        if (typeof window === 'undefined' || !window.freestar) return null;
        if (this.state.isWide) {
            return <FreestarAdSlot placementName={VIDEO_PAGE_SIDEBAR_PLACEMENT} />;
        }
        const footerPlacement = this.props.isTeamOwned
            ? TEAM_VIDEO_PAGE_STICKY_FOOTER_PLACEMENT
            : VIDEO_PAGE_STICKY_FOOTER_PLACEMENT;
        return <FreestarStickyFooter placementName={footerPlacement} />;
    }
}

export default VideoPageAds;
